// extracted by mini-css-extract-plugin
module.exports = {"QrCode":"ccc8Cs","Link":"_h__2x"};